import { useRef, useEffect } from "react";
import _ from "lodash";

// use when need to select multiple options (isMulti prop from react-select)
export const _findArrayOption = (list, selected) => {
  let selectedOption = [];
  selected &&
    selected.forEach((opt) => {
      const compareTo = _.isObject(opt) ? opt.value : opt;
      let listOption = list.find((option) =>
        _.isEqual(option.value, compareTo)
      );
      if (listOption) {
        selectedOption.push(listOption);
      } else {
        // if have optgroup
        for (const item of list) {
          const nestedOptions = item?.options;
          if (nestedOptions) {
            const nestedCompareTo = _.isObject(opt) ? opt.value : opt;
            let nestedListOption = nestedOptions.find((option) =>
              _.isEqual(option.value, nestedCompareTo)
            );

            if (nestedListOption) {
              selectedOption.push(nestedListOption);
            }
          }
        }
      }
    });
  return selectedOption;
};

export const _findOption = (list, selectedOpt) => {
  for (const option of list) {
    if (option?.value) {
      if (!_.isObject(selectedOpt) && _.isEqual(option.value, selectedOpt)) {
        return option;
      } else if (
        _.isObject(selectedOpt) &&
        _.isEqual(option.value, selectedOpt.value)
      ) {
        return option;
      }
    }
    if (option.options) {
      const foundOption = _findOption(option.options, selectedOpt);
      if (foundOption) {
        return foundOption;
      }
    }
  }
  return null;
};

export const _findSelectOption = (list, selectedOpt, isMulti = false) => {
  if (isMulti) {
    return _findArrayOption(list, selectedOpt);
  }

  return _findOption(list, selectedOpt);
};

export const _getBaseUrl = (path = "", themeDir = false) => {
  // const baseUrl = `${window.location.protocol}//${window.location.host}`;

  var element = document.getElementById("base-url");
  var baseUrl = element.getAttribute("data-url");

  if (themeDir) {
    return `${baseUrl}themes/custom/tema/${path}`;
  }

  return `${baseUrl}${path}`;
};

export const _isFirstRender = () => {
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = false;
  }, []);
  return isMountedRef.current;
};

export const _capitalized = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const _getSkipByPage = (page, take) => {
  const defaultSkip = 0;
  const newSkipNumber = page === 1 ? defaultSkip : (page - 1) * take;
  return newSkipNumber;
};

export const _generateRandomId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const _getTranslation = (translationKey) => {
  const translationElm = document.getElementById("tema-translations");
  const translationsValues = translationElm
    ? translationElm.getAttribute("data-translations")
    : null;
  const translations = translationsValues ? JSON.parse(translationsValues) : {};

  return translationKey in translations
    ? translations[translationKey]
    : `Translation key "${translationKey}" cannot be found.`;
};

export const _getCSRFTokenValue = async () => {
  let token = null;

  await fetch(`${_getBaseUrl()}session/token`)
    .then((response) => {
      token = response.text();
    })
    .catch((error) => {
      console.error("Error fetching CSRF token:", error);
    });

  return token;
};

export const _makeId = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const _validateForm = (check, formData) => {
  return Object.keys(check).reduce((obj, key) => {
    if (
      formData[key] === undefined ||
      formData[key] === null ||
      formData[key] === "" ||
      formData[key].length === 0 ||
      formData[key][0] === ""
    ) {
      obj[key] = [check[key]];
    } else if (key === "email") {
      const email = formData[key];

      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regex.test(String(email).toLowerCase()) === false) {
        obj[key] = ["Invalid email format"];
      }
    }
    return obj;
  }, {});
};

export const _getPlaceHolderKey = (type) => {
  switch(type) {
    case 'blogType':
      return 'all_type'
      break;
    case 'region':
      return 'all_region'
      break;
    case 'theme':
      return 'all_theme'
      break;
    case 'themes':
      return 'all_theme'
      break;
    case 'type':
      return 'all_type'
      break;
    case 'languages':
      return 'all_languages'
      break;

    default:
      break;
  }
};

export const findThemeByName = (tree, themeName) => {
  for (const item of tree) {
    if (item.name === themeName) {
      return item; // Found the theme
    }
    if (item.children) {
      const foundSubtheme = findThemeByName(item.children, themeName);
      if (foundSubtheme) {
        return foundSubtheme; // Found the theme in the children
      }
    }
  }
  return null; // Theme not found
};

export const findQuestionsByName = (theme, questionNames) => {
  const qids = [];

  theme.children.forEach((item) => {
    if (questionNames.includes(item.name)) {
      // maintain same structure as CheckboxTree options
      qids.push({
        id: item.qid,
        idType: "qid",
      });
    }
  });

  return qids;
};

export const getAllTids = (tree, tids = []) => {
  for (const item of tree) {
    if (item.tid) {
      tids.push({ id: item.tid, idType: "tid" });
    }
    if (item.children) {
      getAllTids(item.children, tids);
    }
  }
  return tids;
};

export const _getSelectedOption = (options, selectedValue, isTopics = false) => {
  // console.log('_getSelectedOption', options, selectedValue);

  if (isTopics) {
    let option = null;

    options.map((item) => {
      // Parent topic
      if (item.value === selectedValue) {
        option = item;
      } else if (item.subTopics !== undefined) {
        // Subtopics
        let find = item.subTopics.find((topic) => {
          return topic.value === selectedValue;
        });

        if (find !== undefined) {
          option = find;
        }
      }
    });

    if (option !== null) {
      return option;
    }
  }

  return options.find((item) => {
    return item.value === selectedValue;
  });
}

export const _truncateString = (inputString, maxWords) => {
  // Split the input string into an array of words
  const words = inputString.split(' ');

  if (words.length <= maxWords) { return inputString; }

  // Truncate the array to a maximum of maxWords elements
  const truncatedWords = words.slice(0, maxWords);

  // Join the truncated words back together with a space
  let truncatedString = truncatedWords.join(' ');

  // Add trailing "..." if the original string is longer than maxWords
  if (words.length > maxWords) {
      truncatedString += ' ...';
  }

  return truncatedString;
}
